import React from "react";

import { Redirect, RouteComponentProps } from "react-router";

import { EmptyState, ScreenContainer, Link } from "../components/wombat-ui";
import useGetReport from "../graphql/hooks/queries/useGetReport";
import useTranslations from "../hooks/useTranslations";
import { isUnauthorized } from "../utils/errors";
import ReportScreen from "./ReportScreen";

type ReportScreenLoaderProps = RouteComponentProps<{
  reportId: string;
}>;

const ReportScreenLoader: React.FC<ReportScreenLoaderProps> = ({
  match: {
    params: { reportId },
  },
}) => {
  const { data, loading, error } = useGetReport({
    variables: { id: reportId },
  });
  const t = useTranslations();
  const report = data?.report;

  return (
    <ScreenContainer
      loading={loading}
      error={
        error ? (
          <EmptyState
            title={
              isUnauthorized(error) && (t("network.unauthorized") as string)
            }
            action={
              <Link variant="button" to="/">
                {t("network.backToHome")}
              </Link>
            }
          />
        ) : undefined
      }
    >
      <ReportScreen report={report} />
    </ScreenContainer>
  );
};

export default ReportScreenLoader;
